import Dictionary from '../../utils/dictionary';
export class EventBus {
    static clear() {
        EventBus.eventStack = new Dictionary();
        if (EventBus.timers) {
            EventBus.timers.map((st) => {
                clearTimeout(st);
            });
        }
    }
    static on(id, func, opts) {
        let _observer = {
            id: id,
            func: func,
            exipred: new Date().getTime()
        };
        EventBus.eventStack.set(id, _observer);
        if (opts && opts.timeout && opts.timeout > 0) {
            let _st = setTimeout(() => {
                if (EventBus.eventStack.has(id)) {
                    this.notify(id, { code: 502 });
                    this.remove(id);
                }
            }, opts.timeout);
            EventBus.timers.push(_st);
        }
    }
    static remove(id) {
        EventBus.eventStack.delete(id);
    }
    static notify(id, data) {
        if (EventBus.eventStack.has(id)) {
            EventBus.eventStack.get(id).func(data);
        }
    }
    static initBus() {
    }
}
EventBus.eventStack = new Dictionary();
EventBus.timers = new Array();
//# sourceMappingURL=eventBus.js.map